module.exports = __webpack_public_path__ + "img/it.46c8aa8b.png";